export default __webpack_public_path__ + "static/media/1 map_of_India (1).bc1c374a.jpg";